<div class="app-container">
    <div class="header-wrapper" *ngIf="showAuthenticatedShell()">
        <app-header></app-header>
    </div>
    <div class="content-container-wrapper">
        <router-outlet></router-outlet>
    </div>
</div>



